// src/pages/vendas/ModalTefManual.js
import React, { useEffect, useRef, useState } from 'react';
import Select from '../../components/input/Select';
import { useNotaPag } from '../../contexts/vendas/NotaPagContext';
import InputCheck from '../../components/input/InputCheck';
import Input from '../../components/input/Input';
import { useMessage } from '../../contexts/geral/MessageContext';
import { confirmarTefManualPDV } from '../../services/vendas/PDVService.js';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import { ModalActionButton } from '../../components/modalForm/ModalActions';

const ModalTefManual = ({
  show,
  onResolve,
  configTEF,
  //notaPag,
}) => {
  const {showMessage} = useMessage();
  const {fetchNotaPags, notaPagSel} = useNotaPag();
  const [configTEFSel, setConfigTEFSel] = useState(configTEF || null);
  
  const [bandeira, setBandeira] = useState('');
  const [autorizacao, setAutorizacao] = useState('');
  const [semTef, setSemTef] = useState(false);
  const salvandoRef = useRef(false);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (show && configTEF?.id) setConfigTEFSel(configTEF);
  }, [show, configTEF]);
  useEffect(() => {
    if (show) {
      setBandeira('');
      setAutorizacao('');
      setSemTef(false);
    }
  }, [show, notaPagSel?.id]);
  

  const handleConfirmTef = async () => {
    if (salvandoRef.current) return;
    if (!notaPagSel?.id || !configTEFSel?.id) {
      showMessage("Nenhum pagamento foi selecionado para o TEF manual.", "warning");
      return;
    }
    const ehPix = Number(notaPagSel?.formaPag?.meioPag) === 17;
    if (!semTef && (!autorizacao || (!ehPix && !bandeira))) {
      showMessage("Por favor, preencha todos os campos obrigatórios.", "warning");
      return;
    }

    salvandoRef.current = true;
    setSalvando(true);
    try {
    const resultado = await confirmarTefManualPDV({
      notaPagId: notaPagSel.id,
      configTEFId: configTEFSel.id,
      autorizacao,
      bandeira: ehPix ? 'Outros' : bandeira,
      tefNaoIntegrado: semTef
    });
    if (resultado?.pago !== true) throw new Error('O pagamento manual não foi confirmado.');
    const pagamentos = await fetchNotaPags(notaPagSel.notaId, { atualizarEstado: false });
    if (!Array.isArray(pagamentos)) throw new Error('Não foi possível consultar o pagamento aprovado. Tente consultar novamente.');

    setBandeira('');
    setAutorizacao('');
    setSemTef(false);
    onResolve(true, pagamentos);
    } catch (error) {
      showMessage(error?.message || 'Não foi possível confirmar o TEF manual.', 'danger');
    } finally {
      salvandoRef.current = false;
      setSalvando(false);
    }
  };

  if (!show) return null;

  return (
    <ModalContainer show={show} variant="cadastro" onHide={() => { if (!salvandoRef.current) onResolve(false); }} largura="400px">
          <ModalHeader title="Informações do TEF Manual" closeDisabled={salvando} onHide={() => { if (!salvandoRef.current) onResolve(false); }} />
          <ModalBody>
            <div className="mb-3">
              <Input label="Terminal" value={configTEFSel?.nomeTerminal || ''} size={250} disabled />
              <Input label="Forma de Pagamento" value={notaPagSel?.formaPag?.descricao || ''} size={250} disabled />
            </div>

            {Number(notaPagSel?.formaPag?.meioPag) !== 17 && (
              <div className="mb-3">              
                <Select
                  label="Bandeira"
                  disabled={salvando}
                  value={bandeira}
                  onChange={(e) => setBandeira(e.target.value)}
                  options={[
                      { value: '', label: 'Selecione...' },
                      { value: 'Visa', label: 'Visa' },
                      { value: 'Mastercard', label: 'Mastercard' },
                      { value: 'Elo', label: 'Elo' },
                      { value: 'Hipercard', label: 'Hipercard' },
                      { value: 'Amex', label: 'Amex' },
                      { value: 'Cabal', label: 'Cabal' },
                      { value: 'SoroCred', label: 'SoroCred' },
                      { value: 'Outros', label: 'Outros' }                      
                  ]}
                  size={250}
              />
              </div>
            )}


            <div className="input-group">
              {!semTef && (                             
                <Input
                    label="Nº da Autorização"
                    disabled={salvando}
                    value={autorizacao}
                    size={150}
                    onChange={(e) => setAutorizacao(e.target.value)}                                      
                    placeholder="Ex: 123456"
                />                
              )}
              
              <InputCheck
                  label="Nota sem TEF"
                  disabled={salvando}
                  checked={semTef}
                  onChange={() => setSemTef(!semTef)}
              />
            </div>


            
          </ModalBody>
          <ModalFooter>
            <ModalActionButton action="close" disabled={salvando} onClick={() => onResolve(false)}>Cancelar</ModalActionButton>
            <ModalActionButton action="confirm" disabled={salvando} onClick={handleConfirmTef}>Confirmar</ModalActionButton>
          </ModalFooter>
    </ModalContainer>
  );
};

export default ModalTefManual;
